(() => {
  if (customElements.get('nekoan-recommendations')) return;
  class NekoanRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      if (this.querySelector('[data-recommendation-track]')) this.connectRail();
      else {
        this.load();
      }
    }
    async load() {
      try {
        const response = await fetch(this.dataset.url, {signal:this.controller.signal});
        if (!response.ok) throw new Error('Recommendations unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('nekoan-recommendations');
        if (!content || !content.querySelector('[data-recommendation-track]')) {
          this.hidden = true;
          return;
        }
        this.replaceChildren(...content.childNodes);
        this.connectRail();
        this.filterMostLoved();
      } catch (error) {
        if (error.name !== 'AbortError') this.hidden = true;
      }
    }
    filterMostLoved() {
      const loved = this.parentElement.querySelector('[data-most-loved]');
      if (!loved) return;
      const ids = new Set([...this.querySelectorAll('[data-recommendation-id]')].map(card => card.dataset.recommendationId));
      loved.querySelectorAll('[data-loved-id]').forEach(card => {
        if (ids.has(card.dataset.lovedId)) card.remove();
      });
      loved.hidden = !loved.querySelector('[data-loved-id]');
    }
    connectRail() {
      this.track = this.querySelector('[data-recommendation-track]');
      this.cards = [...this.track.children];
      this.controls = this.querySelector('[data-recommendation-controls]');
      this.previous = this.querySelector('[data-recommendation-previous]');
      this.next = this.querySelector('[data-recommendation-next]');
      this.dots = this.querySelector('[data-recommendation-dots]');
      const signal = this.controller.signal;
      this.previous.addEventListener('click', () => this.go(this.current - 1), {signal});
      this.next.addEventListener('click', () => this.go(this.current + 1), {signal});
      this.track.addEventListener('scroll', () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {this.frame = 0;this.sync();});
      }, {passive:true,signal});
      this.resize = new ResizeObserver(() => this.sync());
      this.resize.observe(this.track);
      this.sync();
    }
    go(index) {
      const i = Math.max(0,Math.min(this.positions.length - 1,index));
      const left = this.positions[i];
      this.track.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
    sync() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.controls.hidden = max < 2;
      this.positions = [...new Set(this.cards.map(card => Math.min(Math.round(card.offsetLeft - this.cards[0].offsetLeft),Math.round(max))))];
      if (this.dots.children.length !== this.positions.length) {
        this.dots.replaceChildren();
        this.positions.forEach((position,index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', `${this.dataset.slideLabel} ${index + 1}`);
          button.addEventListener('click', () => this.go(index), {signal:this.controller.signal});
          this.dots.append(button);
        });
      }
      this.current = this.positions.reduce((best,position,index) => Math.abs(position - this.track.scrollLeft) < Math.abs(this.positions[best] - this.track.scrollLeft)?index:best,0);
      this.previous.disabled = this.track.scrollLeft < 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
      [...this.dots.children].forEach((dot,index) => dot.setAttribute('aria-current', String(index === this.current)));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.controller = null;
    }
  }
  customElements.define('nekoan-recommendations', NekoanRecommendations);
})();
